module.exports = __webpack_public_path__ + "static/media/icon-truck-reclaim-requested.4a6fdf29.png";